<template>
  <div class="main-wrapper">
    <!-- <layout-header></layout-header> -->
    <!-- Page Content -->
    <div class="content bg-white">
      <div class="container">
        <div>
          <router-link to="/">
            <img :src="config.base_url_for_Image + main_data" class="img-fluid" alt="Login Banner"
              style="height: 50px;" />
          </router-link>
        </div>
        <div class="row">
          <div class="col-md-10 offset-md-1">
            <!-- Account Content -->
            <div class="account-content">
              <div style="display: flex; flex-direction: row;">
                <div class="col-md-12 col-lg-6 ml-5 mt-5 mb-5 login-left">
                  <img :src="'https://develop-physio.kneexpert.in' + register_doctor.loginPageImage" class="img-fluid" alt="Login Banner"
                    style="height: 370px; border-radius: 15px; margin-left: -48px; margin-top: 17px;" />

                </div>

                <div class="col-md-12 col-lg-5 login-right">
                  <div class="login-header">
                    <div class="switcher">
                      I am
                      <label class="m-2">
                        <input type="radio" name="type" @change="onChange('patient')" />
                        <span class="checkmark"></span> Patient
                      </label>
                      <label class="m-2">
                        <input type="radio" name="type" checked @change="onChange('doctor')" />
                        <span class="checkmark"></span> Doctor
                      </label>
                    </div>
                  </div>
                  <!-- Register Form -->
                  <form @submit.prevent="submit_doctor">
                    <div class="input-group form-group">
                      <div class="input-group-prepend">
                        <div class="input-group-text">Dr.</div>
                      </div>
                      <input type="text" name="first_name" required class="form-control" placeholder="First Name"
                        v-model="register_doctor.first_name"
                        oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, '');" />
                    </div>
                    <div class="form-group">
                      <input type="text" name="last_name" required class="form-control floating"
                        v-model="register_doctor.last_name" placeholder="Last Name"
                        oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, '');" />
                    </div>
                    <div class="form-group">
                      <input type="email" required v-model="register_doctor.email" class="form-control floating"
                        placeholder="Email *" />
                    </div>
                    <div class="input-group form-group">
                      <div class="input-group-prepend">
                        <div class="input-group-text">91</div>
                      </div>
                      <input type="text" required maxlength="10" minlength="10" @keypress="onlyNumber"
                        @keydown.enter="sendOtpOnEnter" oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                        v-model="register_doctor.mobile_no" class="form-control floating" placeholder="Whatsapp Number *" />
                    </div>
                  
                          <div class="form-group">
                            <v-select name="city" required="" label="city" placeholder="Select City"
                              v-model="register_doctor.city" :reduce="(option) => option.city" :options="cities"  @input="onCitySelect">
                            </v-select>
                          </div>
                          <div class="form-group">
                      <v-select
  name="suburb"
  required
  label="label"
  placeholder="Select Suburb"
  v-model="register_doctor.suburb"
  :reduce="(option) => option.value"
  :options="suburbs"
/>
                    </div>
                    <div class="form-group">
                      <v-select label="sub_category_name" placeholder="Select Practitioner Category"
                        v-model="register_doctor.healthcare_practitioner_category"
                        :reduce="(option) => option.sub_category_name" :options="healthcare_practitioner_categories"
                        required>
                      </v-select>
                    </div>
                    <div class="form-group">
                      <label class="custom_check ml-2" style="margin-top: -10px; font-size: 12px;">
                        <input type="radio" name="agreement" checked required />
                        <span class="checkmark"></span>I read Terms and Conditions and By signing up, I agree to
                        <span><a href="javascript:void(0);" style="color: #00b3d0" @click="Open_terms()">terms</a></span>
                      </label>
                    </div>
                    <div class="text-left" style="margin-top: -20px; margin-bottom: 20px;">
                      <router-link class="forgot-link" to="/login">Already have an account?</router-link>
                    </div>
                    <button ref="sendOtpButton" class="btn btn-primary btn-block btn-lg login-btn mb-2" type="submit"
                      :disabled="isDisabled" @click="submit_doctor">
                      Send OTP
                    </button>
                  </form>

                  <!-- /Register Form -->
                </div>

              </div>
            </div>
            <!-- /Account Content -->
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Content -->
    <layout-footer></layout-footer>
  </div>
</template>

<script>
import CommonApi from "../../../services/CommonApi";
import config from "../../../services/CommonApi";
import axios from "axios";
export default {
  data() {
    return {
      cities: [],
      suburbs:[],
      config: config,
      main_data: "",
      healthcare_practitioner_categories: [],
      register_success: true,
      register_error: true,
      disabled: true,
      register_doctor: {
        first_name: "",
        last_name: "",
        email: "",
        mobile_no: "",
        city: "",
        suburb:"",
        healthcare_practitioner_category: "",
        password: "",
        loginPageImage: "",
        selectedCountryCode: '91',
      },

    };
  },

  watch: {
    register_doctor: {
      handler() {
        this.validateForm();
      },
      deep: true,
    },
  },
  mounted() {
    this.get_practitioner_profile();
    this.get_cities();
    this.get_healthcare_categories();
  },

  computed: {
    isDisabled() {
      // Check if all required fields are filled, including city
      return (
        !this.register_doctor.first_name ||
        !this.register_doctor.last_name ||
        !this.register_doctor.email ||
        !this.register_doctor.mobile_no ||
        !this.register_doctor.city ||
        !this.register_doctor.suburb ||
        !this.register_doctor.healthcare_practitioner_category
      );
    },
  },


  methods: {

    onCitySelect(selectedCity) {
      this.register_doctor.city = selectedCity;
    },

    async get_practitioner_profile() {
      var domain = window.location.hostname;

      const formdata = {
        domain: window.location.hostname,
      };
      await axios
        .get(
          "https://develop-physio.kneexpert.in/api/method/sahaj.domain.get_hospital?domain=" +
          window.location.hostname
        )
        .then((res) => {
          this.showspinner = false;
          if (res.data.status_code == 200) {
            this.main_data = res.data.data[0].logo;
            this.register_doctor.loginPageImage = res.data.data[0].login_page;

            // Check if domain_for is "City Portal" and set the default city
            if (res.data.data[0].domain_for === "City Portal") {
              this.register_doctor.city = res.data.data[0].city;
            } else if (res.data.data[0].domain_for === "Hospital Portal") {
              this.register_doctor.city = res.data.data[0].hospital_city;
            }
          }

          if (res.data.status_code == 404) {
            if (window.location.hostname == "physio.sahajhelp.com") {
            } else if (window.location.hostname == "physio.kneexpert.in") {
            } else if (window.location.hostname == "localhost") {
            } else if (window.location.hostname.startsWith("192.168")) {
            } else if (window.location.hostname == "iitb.smartyhealthcare.in") {
            } else {
              window.location.href = String("https://physio.kneexpert.in");
            }
          }

          this.$swal.close();
        });
    },



    /* Form Validation */
    /* Form Validation */
    validateForm() {
      if (
        this.register_doctor.healthcare_practitioner_category === "" ||
        this.register_doctor.healthcare_practitioner_category === null
      ) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    },

    sendOtpOnEnter(event) {
      if (event.key === "Enter" && !this.disabled) {
        console.log("Enter key pressed");
        this.$refs.sendOtpButton.click();
      }
    },


    Open_terms() {
      var pdf = "https://develop-physio.kneexpert.in/files/terms_condition.pdf";
      window.open(pdf);
    },

    onChange(user) {
      if (user === "patient") {
        this.$router.push("/patient/register");
      } else {
        this.$router.push("/doctor/register");
      }
    },

    //Allow User to type number only
    onlyNumber($event) {
      //console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },


    async onCitySelect(selectedCity) {
      this.register_doctor.city = selectedCity;
      if (selectedCity) {
            try {
                const response = await axios.get(
                    `https://develop-physio.kneexpert.in/api/method/sahaj.knee_lead_portal.get_suburb?city=${selectedCity}`
                );
                if (response.data.data) {
        this.suburbs = response.data.data.map((suburb) => ({
          label: suburb.zone,
          value: suburb.name,
        }));
        console.log("Fetched suburbs:", this.suburbs);
      } else {
        this.suburbs = [];
        console.warn("No suburbs found.");
      }
            } catch (error) {
                console.error("Error fetching suburb data:", error);
            }
          }
        },



        async get_cities() {
  const hospitalInfo = await this.get_practitioner_profile();
  if (hospitalInfo) {
    this.selected_city = hospitalInfo.city;
  }

  // Explicitly make a request without the Authorization header
  await axios
    .get("https://develop-physio.kneexpert.in/api/method/sahaj.finalapi.get_city", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        // Ensure Authorization header is omitted
      },
    })
    .then((res) => {
      this.cities = res.data.message;
    })
    .catch((error) => {
      console.error("Error fetching cities:", error);
    });
},
    /* Get Healthcare Categories */
    async get_healthcare_categories() {
      await CommonApi.get_data(
        "sahaj.finalapi.get_healthcare_sub_categories"
      ).then((res) => {
        if (res.status_code == 200) {
          this.healthcare_practitioner_categories = res.data;
        }
      });
    },



    async submit_doctor() {
      if (this.register_doctor) {
        this.$swal({
          text: "Sending OTP...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        var bodyFormData = new FormData();
        const fullPhoneNumber = this.register_doctor.selectedCountryCode + this.register_doctor.mobile_no;
        bodyFormData.append("phone", fullPhoneNumber);
        // Include all fields from register_doctor object in the FormDataa
        for (const key in this.register_doctor) {
          if (this.register_doctor.hasOwnProperty(key)) {
            bodyFormData.append(key, this.register_doctor[key]);
          }
        }

        CommonApi.post_data("sahaj.api.send_otp", bodyFormData, true).then(
          (res) => {
            if (res.status_code == 200) {
              this.$router.push({
                name: "enter-register-OTP",
                params: { registeration_data: this.register_doctor},
              });
              this.$swal.close();
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Error",
                text: res.message,
                showConfirmButton: true,
              });
              setTimeout(()=>{
                this.$router.push("/");
              },3000)
             
            }
          }
        );
      }
    },




  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/kneexpert/doctor/Register.vue